module.exports = __webpack_public_path__ + "assets/img/2009.9b82eab2.svg";